import React, {Fragment} from 'react';
import MigrationOverview from "./MigrationOverview";

const MigrationRoute = () => {
    return (
        <Fragment>
            <h1 className="mb-5">Sender Migration</h1>
            <MigrationOverview/>
        </Fragment>
    );
};

export default MigrationRoute;